export const MAILCHIMP_CAMPAIGN_ID_QUERY_PARAM = 'mc_cid';

export const MAILCHIMP_CAMPAIGN_ID_COOKIE_NAME =
  'mailchimp_campaign_id';
